import { BaseEntity } from "yt-ng-framework";

export class PoreskoOslobodjenje extends BaseEntity{
    constructor(){
        super();
    }
    Naziv: string = null;
    Key: string = null;
    Category: string = null;
    ActiveFrom: Date = null;
    ActiveTo: Date = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Key = input.Key;
        this.Category = input.Category;
        this.ActiveFrom =  input.ActiveFrom;
        this.ActiveTo = input.ActiveTo;
        return this;
    }

    Serialize(input: PoreskoOslobodjenje){
        return input;
    }
}